import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons'

interface BackButtonProps {
  onClick: () => void
  text: string
  className?: string
}

const BackButton = ({ onClick, text, className }: BackButtonProps) => {
  return (
    <button
        className={`gw-competency-back-button ${className}`}
        type="button"
        onClick={onClick}
      >
        <FontAwesomeIcon icon={faChevronLeft} />
        {text}
      </button>
  )
}

export default BackButton